import React from 'react'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'
import {GET_ELEMENT} from './graphql'
import BlockWithLoader from '../../Support/BlockWithLoader'
import ElementForm from '../ElementForm'
import ProjectForm from '../ProjectForm'

const propTypes = {
  parentId: PropTypes.number.isRequired,
  companiesData: PropTypes.array.isRequired
}

const ElementTab = ({parentId, companiesData}) => {
  return (
    <Query query={GET_ELEMENT} variables={{id: parentId}}
      fetchPolicy='network-only' notifyOnNetworkStatusChange>
      {({data, loading, error, refetch}) => {
        if (error) return <div>An unexpected error occurred</div>
        return (
          <BlockWithLoader loading={loading} renderChildren={true}>
            {!loading && data.element.depth !== 1 &&
            <ElementForm companiesData={companiesData} parentId={parentId} element={data.element} onSaved={refetch}/>}
            {!loading &&  data.element.depth === 1 &&
            <ProjectForm companiesData={companiesData} editData={data.element} onSaved={refetch}/>}
          </BlockWithLoader>
        )
      }
      }
    </Query>
  )
}

ElementTab.propTypes = propTypes

export default ElementTab



// WEBPACK FOOTER //
// ./src/components/Projects/tabs/ElementTab.js